import React from 'react';
import { getLocalTime } from '@store/aiAlerts/summary/helper';
import { ADD_SEPARATOR, BACKEND_NAME_SEPARATOR, NAME_SEPARATOR } from '@components/aiAlerts/AlertsConfig/alertConfig.constants';

export const configLogColumnHeader = [
  {
    title: 'User',
    width: 200,
    resizable: true,
    dataKey: 'user',
    key: 'user'
  },
  {
    title: 'Date',
    width: 150,
    resizable: true,
    dataKey: 'date',
    key: 'date'
  },
  {
    title: 'Change Log',
    flexGrow: 1,
    resizable: true,
    dataKey: 'log',
    key: 'log',
    cellRenderer: ({ rowData }) => (renderDimensionCellData(rowData))
  }
];

export const formatRowData = (data, aiDimensionMapping) => {
  return data
    .reverse()
    .map(logData => {
      const { createdAt, added, deleted } = logData;
      let rawLogData = '';
      let action = '';

      if (added) {
        rawLogData = added;
        action = '<b>Added</b>';
      } else if (deleted) {
        rawLogData = deleted;
        action = '<b>Deleted</b>';
      }

      return {
        ...logData,
        date: getLocalTime(createdAt, null),
        log: getDimensionLogString(rawLogData, action, aiDimensionMapping)
      }
    });
};

const getDimensionLogString = (rawLogData, action, aiDimensionMapping) => {
  const rawDataArr = rawLogData
    .split(NAME_SEPARATOR)
    .map(deletedComb => {
      if (!deletedComb) return '';

      const deletedCombArr = deletedComb
        .split(BACKEND_NAME_SEPARATOR)
        .map(backendName => aiDimensionMapping[backendName] ? aiDimensionMapping[backendName].pulse5Label : backendName);

      const dimensionNum = deletedCombArr.length;
      const isPlural = dimensionNum > 1 ? 's' : '';

      return `${dimensionNum} Dimension${isPlural}: ${deletedCombArr.join(ADD_SEPARATOR)}`
    });

  return [action, ...rawDataArr];
}

const renderDimensionCellData = (rowData) => {
  return <div dangerouslySetInnerHTML={{ __html: rowData.log.join('<br>') }} />
}
